
import { useEffect } from 'react'

export const useLoadOne = ({ loadOne = () => { }, params, onSuccess = () => { }, reloadCounter }) => {
    useEffect(() => {
        loadOne(params.id).then(item => {
            onSuccess(item);
        });
    }, [reloadCounter])
}
